import { render, staticRenderFns } from "./BaseFilterIcon.vue?vue&type=template&id=35f2d896"
import script from "./BaseFilterIcon.vue?vue&type=script&lang=js"
export * from "./BaseFilterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports